import ByUsersChart from './ByUsersChart';

export default ByUsersChart;
